// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3E8ZR","content":"LoadingAlert_content__E-2SJ"};